var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastr1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.53 12.23H4.88999C4.38999 12.23 3.98999 11.83 3.98999 11.33C3.98999 10.83 4.38999 10.43 4.88999 10.43H17.52C18.02 10.43 18.42 10.83 18.42 11.33C18.42 11.83 18.02 12.23 17.52 12.23H17.53Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53 16.04H4.88999C4.38999 16.04 3.98999 15.64 3.98999 15.14C3.98999 14.64 4.38999 14.24 4.88999 14.24H17.52C18.02 14.24 18.42 14.64 18.42 15.14C18.42 15.64 18.02 16.04 17.52 16.04H17.53Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.05 20.25H4.9C4.4 20.25 4 19.85 4 19.35C4 18.85 4.4 18.45 4.9 18.45H12.05C12.55 18.45 12.95 18.85 12.95 19.35C12.95 19.85 12.55 20.25 12.05 20.25Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55 1.76999L16.42 2.93999L16.37 3.39999L16.28 4.22999L16.21 4.87999L16.08 6.04999C16.01 6.73999 15.43 7.25999 14.73 7.25999H7.67001C6.97001 7.25999 6.39001 6.73999 6.32001 6.04999L6.19001 4.86999L6.14001 4.41999L6.02001 3.38999L5.99001 3.07999L5.85001 1.74999L7.09001 2.82999L8.02001 3.64999L8.32001 3.90999L8.79001 3.26999L9.14001 2.78999L11.18 -0.0100098L13.23 2.78999L13.5 3.15999L14.06 3.90999L14.37 3.63999L15.34 2.79999L16.53 1.75999L16.55 1.76999Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55 1.76999L16.42 2.93999L16.37 3.39999L16.28 4.22999L16.21 4.87999L16.08 6.04999C16.01 6.73999 15.43 7.25999 14.73 7.25999H7.67001C6.97001 7.25999 6.39001 6.73999 6.32001 6.04999L6.19001 4.86999L6.14001 4.41999L6.02001 3.38999L5.99001 3.07999L5.85001 1.74999L7.09001 2.82999L8.02001 3.64999L8.32001 3.90999L8.79001 3.26999L9.14001 2.78999L11.18 -0.0100098L13.23 2.78999L13.5 3.15999L14.06 3.90999L14.37 3.63999L15.34 2.79999L16.53 1.75999L16.55 1.76999Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.46 3.63L18.38 4.45L18.26 5.6C19.69 6.6 20.62 8.25 20.62 10.12V18.67C20.62 21.71 18.16 24.18 15.12 24.18H7.3C4.27 24.18 1.8 21.71 1.8 18.67V10.12C1.8 8.25 2.74 6.59 4.17 5.59L4.08 4.7L3.96 3.63C1.61 4.84 0 7.29 0 10.12V18.67C0 22.7 3.28 25.98 7.3 25.98H15.12C19.15 25.98 22.42 22.7 22.42 18.67V10.12C22.42 7.29 20.81 4.84 18.46 3.63Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.42,
    height: 25.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastr1);
export default __webpack_public_path__ + "static/media/Mastr_1.80adf76dafcc6785e2102e516e69a790.svg";
export { ForwardRef as ReactComponent };